export default __webpack_public_path__ + "static/media/txt.6ec90ec1.svg";